import React from 'react';
import { Info } from 'lucide-react';
import styles from './NotReleased.module.css';

// What a school's member sees on the Points page before an Admin releases it (points slice 4b): a calm
// information card in the page's card style, centred, so it does not read as an error (Doug, 2026-10-26).
const NotReleased = () => (
  <div className={styles.card}>
    <div className={styles.icon}>
      <Info size={24} />
    </div>
    <p className={styles.text}>The points for this meet have not been released yet.</p>
  </div>
);

export default NotReleased;
